import React, { useState, useCallback, useRef } from "react";
import styles from "./CalendarDropdown.module.scss";
import Icon from "../../../common/Icon/Icon";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../redux/hooks";
import {
  getFullMonthYear,
  getShortMonthYear,
  getShortYear,
  getUniqueYears,
} from "../../../../utils/common";
import useClickOutside from "../../../CustomHooks/useClickOutside";

type CalendarPropsType = {
  monthYearList: string[];
  selectedMonth: string | null;
  onselectionMonthYear: (code: string) => void;
  isOnlyYear?: boolean;
  isLoading?: boolean;
  isError?: boolean;
};

const CalendarDropdown: React.FC<CalendarPropsType> = ({
  monthYearList,
  onselectionMonthYear,
  selectedMonth,
  isOnlyYear,
  isLoading,
  isError,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const years = getUniqueYears(monthYearList);
  useClickOutside(dropdownRef, () => setIsOpen(false));
  const dropdownHandler = () => setIsOpen(!isOpen);
  const handleSelect = useCallback(
    (code: string) => {
      onselectionMonthYear(code);
      setIsOpen(false);
    },
    [onselectionMonthYear]
  );
  if (isError || !selectedMonth) return null;
  if (isLoading)
   return(<>
    <div className={`details_loader animate ${styles.calender_loader}`}/>
   </>);

  return (
    <div
      ref={dropdownRef}
      className={`time_selector_dropdown ${styles.time_selector_dropdown} ${isOnlyYear && styles.year_selector}`}
    >
      <div className={styles.input_wrapper} onClick={dropdownHandler}>
        <span className={styles.selected_date}>
          {!isOnlyYear
            ? `${getFullMonthYear(selectedMonth ?? "")}`
            : `PY ${getShortYear(selectedMonth ?? "")}`}
        </span>
        <Icon
          name="down_filled_arrow"
          size={12}
          color={currentTheme === "light" ? "#2c2c2c" : "#D8D8D9"}
        />
      </div>
      {isOpen && (
        <div className={`dropdown_list ${styles.dropdown_list}`}>
          {!isOnlyYear
            ? monthYearList.map((code) => (
                <div
                  key={code}
                  className={`dropdown_item ${styles.dropdown_item} ${
                    selectedMonth === code ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(code)}
                >
                  <span>{getShortMonthYear(code)}</span>
                  {selectedMonth === code && (
                    <Icon
                      name="tick_icon"
                      size={17}
                      color={currentTheme === "light" ? "#5969D6" : "#99B2F5"}
                    />
                  )}
                </div>
              ))
            : years.map(({ year, code }) => (
                <div
                  key={year}
                  className={`dropdown_item ${styles.dropdown_item} ${
                    selectedMonth === code ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(code)}
                >
                  <span>{`PY ${getShortYear(year)}`}</span>
                  {selectedMonth === code && (
                    <Icon
                      name="tick_icon"
                      size={17}
                      color={currentTheme === "light" ? "#5969D6" : "#99B2F5"}
                    />
                  )}
                </div>
              ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CalendarDropdown);
